import { FormattedDateTimeWithDelimiter } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportedInvoiceDetailAccordion } from '../ImportedInvoiceDetailAccordion'
import { ImportedInvoiceDetailRow, ImportedInvoiceDetailRows } from '../ImportedInvoiceDetailRows'

interface ImportedInvoiceDetailHistoryProps {
  approvedAt: string
  uploadDate: string
}

export const ImportedInvoiceDetailHistory = ({
  approvedAt,
  uploadDate,
}: ImportedInvoiceDetailHistoryProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <ImportedInvoiceDetailAccordion icon="clock" title={t('imported_invoices.detail.invoice_history')}>
      <ImportedInvoiceDetailRows>
        <ImportedInvoiceDetailRow
          label={t('imported_invoices.detail.approval_date')}
          value={<FormattedDateTimeWithDelimiter separator="•" value={approvedAt} />}
        />
        <ImportedInvoiceDetailRow
          label={t('imported_invoices.detail.upload_date')}
          value={<FormattedDateTimeWithDelimiter separator="•" value={uploadDate} />}
        />
      </ImportedInvoiceDetailRows>
    </ImportedInvoiceDetailAccordion>
  )
}
